export default {
    initEnvironment: () => {
        return {
            url: '/myfhe/initialize',
            method: 'GET'
        };
    }
};



// WEBPACK FOOTER //
// ./environments/myfhe/api.js